const isSameValue = (firstValue, secondValue) => {
    if (firstValue !== secondValue) {
        return true;
    }
    return false;
};

const isInTextLength = (value, maxLength) => {
    const valueLength = `${value}`.length;
    if (valueLength > maxLength) {
        return true;
    } else {
        return false;
    }
};

const regEx = (value, regExParams) => {
    const params = new RegExp(regExParams);
    if (params.test(value)) {
        return false;
    } else {
        return true;
    }
};

const isValidEmail = (email) => {
    const re = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;

    if (re.test(String(email).toLowerCase())) {
        return true;
    } else {
        return false;
    }
};

const testPassword = (password) => {
    if (
        password.match(/[a-z]/g) &&
        password.match(/[A-Z]/g) &&
        password.match(/[0-9]/g) &&
        password.match(/[^a-zA-Z\d]/g) &&
        password.length >= 8
    ) {
        return true;
    } else {
        return false;
    }
};

const DNI_REGEX = /^(\d{8})([A-Z])$/;
const CIF_REGEX = /^([ABCDEFGHJKLMNPQRSUVW])(\d{7})([0-9A-J])$/;
const NIE_REGEX = /^[XYZ]\d{7,8}[A-Z]$/;

const validateSpanishID = (str) => {
    str = str.toUpperCase().replace(/\s/, "");

    let valid = false;
    const type = spainIdType(str);

    switch (type) {
        case "dni":
            valid = validDNI(str);
            break;
        case "nie":
            valid = validNIE(str);
            break;
        case "cif":
            valid = validCIF(str);
            break;
        default:
            break;
    }

    return {
        type,
        valid,
    };
};

const spainIdType = (str) => {
    if (str.match(DNI_REGEX)) {
        return "dni";
    }
    if (str.match(CIF_REGEX)) {
        return "cif";
    }
    if (str.match(NIE_REGEX)) {
        return "nie";
    }
};

const validDNI = (dni) => {
    const dni_letters = "TRWAGMYFPDXBNJZSQVHLCKE";
    const letter = dni_letters.charAt(parseInt(dni, 10) % 23);

    return letter === dni.charAt(8);
};

const validNIE = (nie) => {
    let nie_prefix = nie.charAt(0);

    switch (nie_prefix) {
        case "X":
            nie_prefix = "0";
            break;
        case "Y":
            nie_prefix = "1";
            break;
        case "Z":
            nie_prefix = "2";
            break;
        default:
            break;
    }

    return validDNI(nie_prefix + nie.substring(1));
};

const validCIF = (cif) => {
    if (!cif || cif.length !== 9) {
        return false;
    }

    const letters = ["J", "A", "B", "C", "D", "E", "F", "G", "H", "I"];
    const digits = cif.substr(1, cif.length - 2);
    const letter = cif.substr(0, 1);
    const control = cif.substr(cif.length - 1);
    let sum = 0;
    let i;
    let digit;

    if (!letter.match(/[A-Z]/)) {
        return false;
    }

    for (i = 0; i < digits.length; ++i) {
        digit = parseInt(digits[i], 10);

        if (isNaN(digit)) {
            return false;
        }

        if (i % 2 === 0) {
            digit *= 2;
            if (digit > 9) {
                digit = parseInt(String(digit / 10), 10) + (digit % 10);
            }

            sum += digit;
        } else {
            sum += digit;
        }
    }

    sum %= 10;
    digit = (sum !== 0) ? 10 - sum : sum;

    if (letter.match(/[ABEH]/)) {
        return String(digit) === control;
    }
    if (letter.match(/[NPQRSW]/)) {
        return letters[digit] === control;
    }

    return String(digit) === control || letters[digit] === control;
};

const validIBAN = (iban) => {
    if (iban) {
        iban = iban.replace(/\s/g, "").toUpperCase();

        if (iban.length !== 24) {
            return false;
        }

        if (!/^[A-Z]{2}\d{22}$/.test(iban)) {
            return false;
        }

        iban = iban.substring(4) + iban.substring(0, 4);

        var ibanArray = [];
        for (var i = 0; i < iban.length; i++) {
            var charCode = iban.charCodeAt(i);
            if (charCode >= 65 && charCode <= 90) {
                ibanArray.push((charCode - 55).toString());
            } else {
                ibanArray.push(iban.charAt(i));
            }
        }

        var ibanNumber = ibanArray.join("");

        if (module97(ibanNumber) !== 1) {
            return false;
        }

        return true;
    }
    return false;
};

const module97 = (iban) => {
    var remainder = iban;
    var block;

    while (remainder.length > 2) {
        block = remainder.slice(0, 9);
        remainder = (parseInt(block, 10) % 97) + remainder.slice(block.length);
    }

    return parseInt(remainder, 10) % 97;
};

const validPhoneNumber = (phoneNumber) => {
    if (!/^\d{9}$/.test(phoneNumber)) {
        return false;
    }

    return true;
};

const validMobileNumber = (mobileNumber) => {
    if (!/^(?:(?:\+?[0-9]{2,4})?[ ]?[6789][0-9 ]{8,13})$/.test(mobileNumber)) {
        return false;
    }

    return true;
};

const hasValue = (value) => {
    if (value !== null && value !== undefined) {
        if (value instanceof Date && !isNaN(value.getTime())) {
            return true;
        }
        if (typeof value === "string" && value.trim() === "") {
            return false;
        }
        if ((Array.isArray(value) && value.length === 0) || (Array.isArray(value) && value.length > 0 && value[0] === undefined)) {
            return false;
        }
        if (typeof value === "object" && Object.keys(value).length === 0) {
            return false;
        }
        return true;
    }
    return false;
};

export {
    isSameValue,
    isInTextLength,
    regEx,
    isValidEmail,
    testPassword,
    validateSpanishID,
    spainIdType,
    validDNI,
    validNIE,
    validCIF,
    validIBAN,
    validPhoneNumber,
    validMobileNumber,
    hasValue
};
